import { render, staticRenderFns } from "./ModalCampaignDistributionSuccess.vue?vue&type=template&id=108ef629&scoped=true"
import script from "./ModalCampaignDistributionSuccess.vue?vue&type=script&lang=js"
export * from "./ModalCampaignDistributionSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalCampaignDistributionSuccess.vue?vue&type=style&index=0&id=108ef629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ef629",
  null
  
)

export default component.exports